import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AIProvider } from './context/AIContext';
import VerificationGuard from './components/VerificationGuard';
import { publicRoutes } from './routes/publicRoutes';
import AuthedRoutes from './routes/authedRoutes';
import './i18n';

function LoadingScreen(): React.ReactElement {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#F8FAFC' }}>
      <div style={{ textAlign: 'center' }}>
        <img src="/logo-mark-header.png" alt="Novala" style={{ height: 40, width: 'auto', objectFit: 'contain', marginBottom: 8 }} />
        <div style={{ fontSize: 13, color: '#94A3B8' }}>Loading your account...</div>
      </div>
    </div>
  );
}

export default function App(): React.ReactElement {
  const [token, setToken] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const stored = localStorage.getItem('token') || localStorage.getItem('access_token');
    if (stored) setToken(stored);
    setLoading(false);
  }, []);

  const handleLogin = (t: string, email?: string): void => {
    setToken(t);
    localStorage.setItem('token', t);
    if (email) localStorage.setItem('user_email', email);
  };

  if (loading) return <LoadingScreen />;

  return (
    <Router>
      <AIProvider>
        <VerificationGuard />
        <Routes>
          {publicRoutes({ token, onLogin: handleLogin })}
          <Route path="/*" element={token ? <AuthedRoutes /> : <Navigate to="/login" replace />} />
        </Routes>
      </AIProvider>
    </Router>
  );
}

